// Period selector for the integrations dashboard (Hoje / Ontem / 7 dias / 15 dias / 30 dias).
// Date keys use the browser's LOCAL calendar day (not UTC), matching the
// backend, which buckets event_traces by calendar day in the company's local
// timezone (settings.local_timezone, e.g. America/Sao_Paulo - see day_expr in
// src/routes/cloud_event_logs.py). Using UTC here used to make events created
// late at night (after 21h in Brasília time, already past midnight UTC) show
// under "Ontem" instead of "Hoje".

const pad = (n) => String(n).padStart(2, '0')
const toDateKey = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

export const PERIOD_OPTIONS = [
  { value: 'today', label: 'Hoje' },
  { value: 'yesterday', label: 'Ontem' },
  { value: '7d', label: '7 dias' },
  { value: '15d', label: '15 dias' },
  { value: '30d', label: '30 dias' }
]

// Trailing calendar days (including today) covered by each multi-day period.
const PERIOD_DAY_COUNTS = { '7d': 7, '15d': 15, '30d': 30 }

const yesterday = () => {
  const d = new Date()
  d.setDate(d.getDate() - 1)
  return d
}

const daysAgo = (n) => {
  const d = new Date()
  d.setDate(d.getDate() - n)
  return d
}

/**
 * Query params to send to the /stats endpoint for a given period.
 */
export const getPeriodDateRange = (period) => {
  if (period === 'today') {
    const key = toDateKey(new Date())
    return { dateFrom: key, dateTo: key }
  }
  if (period === 'yesterday') {
    const key = toDateKey(yesterday())
    return { dateFrom: key, dateTo: key }
  }
  const dayCount = PERIOD_DAY_COUNTS[period]
  if (dayCount) {
    return { dateFrom: toDateKey(daysAgo(dayCount - 1)), dateTo: toDateKey(new Date()) }
  }
  return { dateFrom: null, dateTo: null }
}

/** Ordered list of local calendar-day date keys (YYYY-MM-DD) covered by a period, oldest first. */
export const getPeriodDayKeys = (period) => {
  if (period === 'today') return [toDateKey(new Date())]
  if (period === 'yesterday') return [toDateKey(yesterday())]

  const dayCount = PERIOD_DAY_COUNTS[period] || 7
  const days = []
  for (let i = dayCount - 1; i >= 0; i--) {
    days.push(toDateKey(daysAgo(i)))
  }
  return days
}
